import { useOutletContext } from 'react-router-dom';
import type { ApiClient, Projekt } from '../../api';
import { PageHeader } from '../../rahmen/PageHeader';
import { LoadingState } from '../../muster';
import { SprachalarmAnsicht } from '../ElektroSprachalarm';
import { ZutrittAnsicht } from '../ElektroZutritt';
import { SicherheitsReiter } from './SicherheitsReiter';

interface Rahmen { api: ApiClient; projekt: Projekt | null }

/**
 * Eigene Routen für Sprachalarm und Zutritt (BM-1, Entscheidung main E2 vom 20.10.2026).
 *
 * Bisher waren beide nur als Reiter der Seite „Brandfallsteuerung und Notstrom" erreichbar. Mit dem Abschnitt
 * „Brandmeldeanlage" steht diese Seite dort; Sprachalarm und Zutritt bekommen deshalb einen eigenen Eintrag im
 * Abschnitt „Sprachalarm und Zutritt". Hier kommt der Seitenkopf dazu; seit SA-1 setzt die Sprachalarm-Ansicht ihn
 * selbst (nach TX-STANDARD S1, mit Rechenstand und ExportLeiste). Seit BM-5 tragen alle drei Seiten dieselben
 * LocalTabs (SicherheitsReiter) statt der Reiter auf `elektro-sicherheitstechnik`.
 */
export function ElektroSprachalarmSeite() {
  const { api, projekt } = useOutletContext<Rahmen>();
  if (!projekt) return <LoadingState />;
  // SA-1: Die Ansicht setzt den Seitenkopf selbst (Rechenstand, ExportLeiste, Kapitel wählen); die LocalTabs stehen darin.
  return <SprachalarmAnsicht api={api} projektId={projekt.id} reiter={<SicherheitsReiter projektId={projekt.id} />} />;
}

export function ElektroZutrittSeite() {
  const { api, projekt } = useOutletContext<Rahmen>();
  if (!projekt) return <LoadingState />;
  return (
    <div className="seite">
      <PageHeader
        titel="Zutritt, Fluchttür, Türüberwachung"
        beschreibung="Türabgleich Zutrittskontrolle, Fluchttürsteuerung, Türüberwachung und Sprechstellen gegen das Modell – mit Nachweis ELT-ZKF und Excel. Gerechnet beim Abruf, nur lesend."
      />
      <SicherheitsReiter projektId={projekt.id} />
      <ZutrittAnsicht api={api} projektId={projekt.id} />
    </div>
  );
}
